const Backbone = require('backbone');
const Base64 = require('crypto-js/enc-base64.js');
const Utf8 = require('crypto-js/enc-utf8.js');
const CONSTANTS = require('./../constants').STORAGE;
var KEY_PREFIX = CONSTANTS.KEY_PREFIX; // UPDATE EVERY YEAR inside /constants/index.js

module.exports = Backbone.Model.extend({
  
  initialize: function (options) {
    
    options = options || {};
      
    if (options.storageMethod && options.storageMethod.match(/cookie/i)) {
      this._storeMethod = 'Cookie';
    } else {
      
      try {
        localStorage.setItem('local_storage_test', 'test');
        localStorage.removeItem('local_storage_test');
        this._storeMethod = 'LocalStorage';
      } catch (e) {
        this._storeMethod = 'Cookie';
      }
    }
  },

  /* Exposed Functions
  -------------------------*/
  save: function (name, value, days) {
    var key = this.get('namespace') ? this.get('namespace') + '_' + name : name;
    this['_set' + this._storeMethod](this.hashKey(key), this.encode(value), days);
  },

  fetch: function (name) {
    var key = this.get('namespace') ? this.get('namespace') + '_' + name : name;
    return this.decode(this['_read' + this._storeMethod](this.hashKey(key)));
  },

  destroy: function (name) {
    var key = this.get('namespace') ? this.get('namespace') + '_' + name : name;
    this['_delete' + this._storeMethod](this.hashKey(key));
  },

  /* COOKIE Functions
  -------------------------*/
  _setCookie: function (key, value, timeGMT) {

    var today = new Date();
    var tomorrow = new Date(today);

    tomorrow.setDate(tomorrow.getDate() + 1);
    var expirationDate = new Date(tomorrow.toDateString() + ' ' + timeGMT);

    document.cookie = key + '=' + value + '; expires=' + expirationDate.toGMTString() + '; path=/';
  },

  _readCookie: function (name) {
          
    var regEx = new RegExp(name + "=[^;]+(;|$)");
    var result = document.cookie.match(regEx);
          
    if (result) return result[0].split(/[;=]/g)[1];
    return null;
  },

  _deleteCookie: function (name) {
    this._setCookie(name, '', -1);
  },

  /* LOCALSTORAGE Functions
  -------------------------*/
  _setLocalStorage: function (name, value) {
    localStorage.setItem(name, value);
  },

  _readLocalStorage: function (name) {
    return localStorage.getItem(name);
  },

  _deleteLocalStorage: function (name) {
    localStorage.removeItem(name);
  },

  hashKey: function (key) {
    
    var hash = 0, i, chr;
    if (key.length === 0) return hash;
    
    key = KEY_PREFIX + key;
    
    for (i = 0; i < key.length; i++) {
      chr = key.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0; // Convert to 32bit integer
    }
    
    return hash;
  },
  
  encode: function (word) {
    return Base64.stringify(Utf8.parse(word));
  },
  
  decode: function (hash) {
    
    if (hash) {
      try {
        var words = Base64.parse(hash);
        return Utf8.stringify(words);
      } catch (err) {
        throw new Error('Storage Model: Error decoding');
      }
    } else {
      return hash;
    }
  }

}, {
  KEY_PREFIX: KEY_PREFIX
});



// WEBPACK FOOTER //
// ./app/scripts/models/storage.js